import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { ContentWithPaddingXl, Container } from "components/misc/Layouts.js";
import { SectionHeading as Heading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-7.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-8.svg";
import client1 from "images/fullview.jpeg";
import client2 from "images/tsingyi.jpg";
import client3 from "images/taikoo.JPG";

const Subheading = tw(SubheadingBase)`text-center`;
const Testimonials = tw.div`flex flex-col lg:flex-row items-center lg:items-stretch`;
const TestimonialContainer = tw.div`mt-16 lg:w-1/3`;
const Testimonial = tw.div`px-4 text-center max-w-xs mx-auto flex flex-col items-center`;
const Image = tw.img`w-20 h-20 rounded-full`;
const Quote = tw.blockquote`mt-5 text-gray-600 font-medium leading-loose`;
const CustomerName = tw.p`mt-5 text-gray-900 font-semibold uppercase text-sm tracking-wide`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute left-0 top-0 h-56 w-56 opacity-15 transform -translate-x-2/3 -translate-y-12 text-teal-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute right-0 bottom-0 h-64 w-64 opacity-15 transform translate-x-2/3 text-yellow-500`}
`;

export default ({
  subheading = "Testimonials",
  heading = "Customer's Review",
  testimonials = [
    {
      imageSrc: client1,
      quote:
        "萬匠的劉師傅是一個非常有責任心的人，從度尺、設計、挑選用料到整個工程，他都跟進得十分妥當。他還特意陪同我們選擇廚房和洗手間的款式，給了很多有用的建議，讓我們感到非常安心和滿意。到目前為止，我們對這個溫暖的家感到非常滿意，這一切都要感謝劉師傅的專業和細心。",
      customerName: "鄭生鄭太 － 富景花園 431呎"
    },
    {
      imageSrc: client2,
      quote:
        "在整個裝修過程中，萬匠的團隊展現了高度的專業精神和細心。他們不僅在每個細節上都做到一絲不苟，還能夠根據我們的需求和喜好，提供個性化的建議和解決方案。無論是選擇材料還是設計風格，他們都能夠給出專業的意見，讓我們感到非常放心。最終的結果超出了我們的預期，我們對這個全新的家感到非常滿意。",
      customerName: "陳生 － 荃灣 586呎"
    },
    {
      imageSrc: client3,
      quote:
        "萬匠的裝修團隊在每一個環節都表現得非常出色。他們不僅在施工過程中保持了高效和有序，還能夠及時解決我們提出的任何問題和疑慮。特別是在選擇家具和裝飾品時，他們的建議非常有幫助，讓我們能夠打造出一個既美觀又實用的居住空間。整個裝修過程非常順利，我們對最終的效果感到非常滿意。",
      customerName: "羅先生 － 太古城 700呎"
    }
  ]
}) => {
  return (
    <Container id="clients">
      <ContentWithPaddingXl>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        <Testimonials>
          {testimonials.map((testimonial, index) => (
            <TestimonialContainer key={index}>
              <Testimonial>
                <Image src={testimonial.imageSrc} />
                <Quote>"{testimonial.quote}"</Quote>
                <CustomerName>- {testimonial.customerName}</CustomerName>
              </Testimonial>
            </TestimonialContainer>
          ))}
        </Testimonials>
      </ContentWithPaddingXl>

      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};
